import { Box, Text, Tooltip } from 'components'
import { getFontSize, getSpacing } from 'utils'

export interface IInfoItemProps {
  label: string
  value: string
  tooltip?: string
  singleLine?: boolean
  futureValue?: string
}

export const InfoItem = ({ label, tooltip, value, singleLine, futureValue }: IInfoItemProps) => {
  const labelLine = (
    <Box flexDirection="row" justifyContent="space-around">
      <Text size="xs" weight="regular" color="TEXT_DARK">
        {label}
      </Text>
      {tooltip && (
        <Box paddingLeft={getSpacing('xs')}>
          <Tooltip content={tooltip} width={getFontSize('m')} />
        </Box>
      )}
    </Box>
  )

  const valueElem = (
    <Text color="WHITE" size="s" weight="medium">
      {value}
      {futureValue && (
        <Text color="TEXT_DARK" size="s" weight="regular">
          &nbsp;→ {futureValue}
        </Text>
      )}
    </Text>
  )

  if (singleLine) {
    return (
      <Box flexDirection="row" alignItems="center" justifyContent="space-between">
        {labelLine}
        {valueElem}
      </Box>
    )
  } else {
    return (
      <Box flexDirection="row" display="block" textAlign="center">
        {labelLine}
        <Box marginTop={getSpacing('s')}>{valueElem}</Box>
      </Box>
    )
  }
}
